export default __webpack_public_path__ + "static/shopee_event-a739d6abd57d6c5f58a883a055b6f2b1.jpg";